import { getComponentFromName } from '@folklore/utils';
import { Suspense } from 'react';

import * as Components from '../../animations/index';

interface AnimationBlockProps {
    name?: string | null;
    [key: string]: unknown;
}

function AnimationBlock({ name = null, ...otherProps }: AnimationBlockProps) {
    const Component = getComponentFromName(Components, name, null);
    return Component !== null ? (
        <Suspense fallback={null}>
            <Component {...otherProps} />
        </Suspense>
    ) : null;
}

export default AnimationBlock;
